import SEO from "@/components/SEO";
import PageHero from "@/components/PageHero";
import { Reveal, Stagger, StaggerItem } from "@/components/Reveal";
import { CTAButton } from "@/components/CTAButton";
import ReviewCard from "@/components/ReviewCard";
import { REVIEWS, BUSINESS } from "@/data/site";

export default function Reviews() {
  return (
    <>
      <SEO title="Reviews" description="What guests say about Chopstick Chinese Corner, Sector 109 Gurugram." />
      <PageHero
        overline="Kind words"
        titleLines={["Straight", "from the", "table."]}
        subtitle="We love hearing from our guests. The notes below are sample testimonials for layout — verified reviews will replace them soon."
      />

      <section className="mx-auto max-w-7xl px-5 md:px-8 py-16 md:py-24">
        <Stagger className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
          {REVIEWS.map((r, i) => (
            <StaggerItem key={i}><ReviewCard review={r} index={i} /></StaggerItem>
          ))}
        </Stagger>

        <Reveal>
          <div className="mt-16 border border-brand-ink/12 bg-white p-8 md:p-12 text-center">
            <h2 className="font-display text-3xl md:text-4xl text-brand-ink">Dined with us?</h2>
            <p className="mt-3 max-w-xl mx-auto text-muted-foreground">
              We&apos;d be grateful for a review — it helps our little corner grow. Or
              just call and tell us what you loved.
            </p>
            <div className="mt-7 flex flex-wrap justify-center gap-3">
              <CTAButton href={BUSINESS.zomatoUrl} variant="primary" target="_blank" rel="noopener noreferrer">Review on Zomato</CTAButton>
              <CTAButton href={`tel:${BUSINESS.phoneHref}`} variant="ghost" icon={false}>Call us</CTAButton>
            </div>
          </div>
        </Reveal>
      </section>
    </>
  );
}
